module.exports = __webpack_public_path__ + "static/img/slide3_h.ea91e1a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide3_h.jpeg
// module id = 68AL
// module chunks = 1